// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"430e7461","284":"e11825a2","436":"5d001ea9","680":"d218ed3b"}[chunkId] + ".chunk.css";
};